import type { PropertyProcessStep } from '../types/propertyDetailTypes'

// "WHAT'S THE PROCESS?" — static product copy (Figma 32590:61766).
export const DEFAULT_PROPERTY_PROCESS_STEPS: PropertyProcessStep[] = [
  {
    step: 1,
    title: 'Purchase Tokens',
    description:
      'Select your investment amount and purchase fractional tokens representing your share of the property.',
  },
  {
    step: 2,
    title: 'Ownership Transfer',
    description:
      'Legal ownership is registered and transferred to you via blockchain-verified documentation.',
  },
  {
    step: 3,
    title: 'Earn Rental Income',
    description:
      'Receive your proportional share of rental income distributed monthly directly to your wallet.',
  },
  {
    step: 4,
    title: 'Exit & Liquidity',
    description:
      'Sell your tokens on the secondary market anytime to unlock full liquidity on your investment',
  },
]

/** A Live offering this close to its window end shows "Closes Soon". */
export const CLOSING_SOON_THRESHOLD_DAYS = 7

/** Starting amount in the investment calculator (Figma shows AED 5,000). */
export const DEFAULT_CALCULATOR_AMOUNT = 5000

/** Holding periods on the calculator's horizon selector. */
export const CALCULATOR_HORIZONS = [
  { key: '6m', label: '6 M', years: 0.5, caption: 'After 6 Months' },
  { key: '1y', label: '1 Y', years: 1, caption: 'After 1 Year' },
  { key: '5y', label: '5 Y', years: 5, caption: 'After 5 Years' },
  { key: '10y', label: '10 Y', years: 10, caption: 'After 10 Years' },
] as const

export type CalculatorHorizonKey = (typeof CALCULATOR_HORIZONS)[number]['key']

export const DEFAULT_CALCULATOR_HORIZON: CalculatorHorizonKey = '5y'
